<div class="main-body">
<router-outlet></router-outlet>
</div>